export default __webpack_public_path__ + "static/media/ICON4.6e92d52d.svg";